import React from 'react';

//Componentes
import UserSearchContainer from '../../components/userSearch/UserSearchContainer';

//Estilos
import './UsersList.css';

function UsersList({ functions, states }) {
    const { register, handleSubmit, onSearch } = functions;

    const { SearchParameters } = states;

    return (
        <div className="usersList-container">
            <section className="usersList-section">
                <h4>Filtro de Búsqueda</h4>
                <form
                    className="usersList-search_form"
                    onSubmit={handleSubmit(onSearch)}
                >
                    <label className="usersList-label">
                        <span>Apellido: </span>
                        <input
                            className="usersList-input"
                            type="text"
                            {...register('apellido')}
                        />
                    </label>
                    <label className="usersList-label">
                        <span>Titular: </span>
                        <input
                            className="usersList-input"
                            type="text"
                            {...register('titular')}
                        />
                    </label>
                    <label className="usersList-label">
                        <span>Correo: </span>
                        <input
                            className="usersList-input"
                            type="email"
                            {...register('correo')}
                        />
                    </label>
                    <label className="usersList-label">
                        <span>RUT: </span>
                        <input
                            type="number"
                            {...register('rut')}
                            onKeyPress={(e) => {
                                if (
                                    !/[0-9]/.test(e.key) ||
                                    e.target.value.length > 20
                                ) {
                                    e.preventDefault();
                                }
                            }}
                        />
                    </label>
                    <label className="usersList-label">
                        <span>BPS: </span>
                        <input
                            type="number"
                            {...register('bps')}
                            onKeyPress={(e) => {
                                if (
                                    !/[0-9]/.test(e.key) ||
                                    e.target.value.length > 20
                                ) {
                                    e.preventDefault();
                                }
                            }}
                        />
                    </label>
                    <label className="usersList-label">
                        <span>Teléfono: </span>
                        <input
                            type="tel"
                            {...register('telefono')}
                            onKeyPress={(e) => {
                                if (
                                    !/[0-9]/.test(e.key) ||
                                    e.target.value.length > 10
                                ) {
                                    e.preventDefault();
                                }
                            }}
                        />
                    </label>
                    <label className="usersList-label">
                        <span>Viñedo: </span>
                        <input
                            type="number"
                            {...register('viniedo')}
                            onKeyPress={(e) => {
                                if (
                                    !/[0-9]/.test(e.key) ||
                                    e.target.value.length > 15
                                ) {
                                    e.preventDefault();
                                }
                            }}
                        />
                    </label>
                    <div className="usersList-form-footer">
                        <button className="btn btn-primary" type="submit">
                            Buscar
                        </button>
                    </div>
                </form>
            </section>
            {Object.keys(SearchParameters.usuarios).length > 0 && (
                <UserSearchContainer />
            )}
        </div>
    );
}

export default UsersList;
